/** 填空题子题：{ label, content, answer, score, analysis? } */

export function defaultSubQuestion(index = 0) {
  return {
    id: `sub-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    label: `(${index + 1})`,
    content: '',
    answer: '',
    score: 2,
    analysis: ''
  }
}

export function relabelSubQuestions(list) {
  return (list || []).map((item, index) => ({
    ...item,
    label: `(${index + 1})`
  }))
}

export function parseSubQuestionsJson(raw) {
  if (!raw) return { material: '', items: [] }
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    if (Array.isArray(parsed)) {
      return {
        material: '',
        items: normalizeSubQuestionItems(parsed)
      }
    }
    if (parsed && typeof parsed === 'object') {
      return {
        material: parsed.material || '',
        items: normalizeSubQuestionItems(parsed.items || [])
      }
    }
    return { material: '', items: [] }
  } catch (e) {
    return { material: '', items: [] }
  }
}

function normalizeSubQuestionItems(list) {
  return (list || []).map((item, index) => ({
    id: item.id || `sub-${index}-${Date.now()}`,
    label: item.label || `(${index + 1})`,
    content: item.content || '',
    answer: item.answer || '',
    score: Number(item.score) || 0,
    analysis: item.analysis || ''
  }))
}

export function serializeSubQuestions(materialHtml, list) {
  return JSON.stringify({
    material: materialHtml || '',
    items: (list || []).map(item => ({
      label: item.label || '',
      content: item.content || '',
      answer: item.answer || '',
      score: Number(item.score) || 0,
      analysis: item.analysis || ''
    }))
  })
}

export function calcSubQuestionTotalScore(list) {
  return (list || []).reduce((sum, item) => sum + (Number(item.score) || 0), 0)
}

export function buildMergedFillAnswer(list) {
  return (list || [])
    .map(item => String(item.answer || '').trim())
    .join('|')
}

export function buildMergedFillContent(materialHtml, list) {
  const parts = []
  if (materialHtml && materialHtml.trim()) {
    parts.push(`<div class="fill-material-block">${materialHtml.trim()}</div>`)
  }
  ;(list || []).forEach((item, index) => {
    const label = item.label || `(${index + 1})`
    const score = Number(item.score) || 0
    const scoreText = score > 0 ? `（${score}分）` : ''
    const body = (item.content || '').trim()
    parts.push(
      `<div class="fill-sub-block">`
      + `<p class="fill-sub-label"><strong>${label}</strong>${scoreText}</p>`
      + `<div class="fill-sub-body">${body}</div>`
      + `</div>`
    )
  })
  return parts.join('')
}

export function buildMergedFillAnalysis(mainAnalysis, list) {
  const subParts = (list || [])
    .map((item, index) => {
      const text = String(item.analysis || '').trim()
      if (!text) return ''
      const label = item.label || `(${index + 1})`
      return `<p><strong>${label}</strong></p>${text}`
    })
    .filter(Boolean)
  const main = String(mainAnalysis || '').trim()
  if (!subParts.length) return main
  if (!main) return subParts.join('')
  return `${main}${subParts.join('')}`
}

export function buildFillQuestionPayload({ materialHtml, subQuestions, mainAnalysis }) {
  const list = subQuestions || []
  return {
    content: buildMergedFillContent(materialHtml, list),
    answer: buildMergedFillAnswer(list),
    analysis: buildMergedFillAnalysis(mainAnalysis, list),
    subQuestionsJson: serializeSubQuestions(materialHtml, list)
  }
}

export function validateSubQuestions(list) {
  if (!list || !list.length) {
    return '请至少添加 1 个子题'
  }
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i]
    const label = item.label || `(${i + 1})`
    if (!String(item.content || '').replace(/<[^>]+>/g, '').trim()) {
      return `${label} 请填写小问内容`
    }
    if (!String(item.answer || '').trim()) {
      return `${label} 请填写答案`
    }
  }
  return ''
}

function highlightFillBlanks(html) {
  return String(html || '')
    .replace(/_{3,}/g, '<span class="fill-blank">________</span>')
    .replace(/（\s*）/g, '<span class="fill-blank">（&nbsp;&nbsp;&nbsp;&nbsp;）</span>')
}

/** 题库列表：填空题（含子题）结构化预览 HTML */
export function buildFillListPreviewHtml(row) {
  if (!row || row.type !== 'FILL') {
    return row && row.content ? row.content : ''
  }
  const { material, items } = parseSubQuestionsJson(row.subQuestionsJson)
  if (!items.length) {
    return highlightFillBlanks(row.content || '')
  }
  const parts = []
  if (material && material.trim()) {
    parts.push(`<div class="fill-preview-material">${highlightFillBlanks(material.trim())}</div>`)
  }
  items.forEach((item, index) => {
    const label = item.label || `(${index + 1})`
    const score = Number(item.score) || 0
    const scoreText = score > 0 ? `<span class="fill-preview-score">（${score}分）</span>` : ''
    const body = highlightFillBlanks((item.content || '').trim())
    parts.push(
      `<div class="fill-preview-sub">`
      + `<span class="fill-preview-label">${label}</span>${scoreText}`
      + `<span class="fill-preview-body">${body}</span>`
      + `</div>`
    )
  })
  return parts.join('')
}

export function getFillSubQuestionSummary(row) {
  if (!row || row.type !== 'FILL') return null
  const { items } = parseSubQuestionsJson(row.subQuestionsJson)
  if (!items.length) return null
  const total = calcSubQuestionTotalScore(items)
  return { count: items.length, totalScore: total }
}
